import { enableHomePublicAccessSession, hasHomePublicAccessSession, verifyHomePublicAccessToken } from '@/modules/navigation/services/homeSettingsService'

// Suporta tanto o link exclusivo (access/public/open)
// quanto o link de afiliado (ref/referral)
export async function ensureExclusiveSessionFromUrl(): Promise<boolean> {
  try {
    const usp = new URLSearchParams(window.location.search)

    // 1) Link exclusivo com token canônico
    const access = (usp.get('access') || usp.get('public') || usp.get('open') || '').trim()
    if (access) {
      const ok = await verifyHomePublicAccessToken(access)
      if (ok) enableHomePublicAccessSession()
      return ok || hasHomePublicAccessSession()
    }

    // 2) Link de afiliado: libera sessão pública nesta aba
    const ref = (usp.get('ref') || usp.get('referral') || '').trim()
    if (ref) {
      enableHomePublicAccessSession()
      return true
    }

    // 3) Sem parâmetros: mantém estado atual
    return hasHomePublicAccessSession()
  } catch {
    return hasHomePublicAccessSession()
  }
}

export function isExclusiveSessionActive(): boolean {
  return hasHomePublicAccessSession()
}
